/* globals AuthenticationContext */

angular.module( 'mtic' ).service( 'IAMManager', function (IAM_CONFIGURATION, $log, $q, cordovaMessenger, PlatformService, EventManager) {

  var eventManager = new EventManager('IAMManager');
  this.getSavedUrlParamsForToken = function () {
    return adalAuthContext._getItem('url_params') || '';
  };

  this.clearSavedUrlParamsForToken = function () {
    adalAuthContext._saveItem('url_params', '')
  }

  /**
   * Attempt to login through ADAL / IAM
   * @return {Promise<{profile}>}
   */
  this.login = function () {
    return $q(function(resolve, reject) {
      var user = adalAuthContext.getCachedUser();
      if (user) {
        resolve(user);
        return;
      }
      if(PlatformService.isApp && PlatformService.isIos){        
        adalAuthContext.popUp = false;
      }else{
        adalAuthContext.popUp = true;
      }
      adalAuthContext.callback = function (err) {
        if(err){
          $log.error(err)
          reject(err)
        }else{
          resolve(adalAuthContext.getCachedUser())
        }
      }
      adalAuthContext._saveItem('url_params', window.location)
      adalAuthContext.login()
    });
  };

  /**
   * Logout from all techniques
   * @return {Promise<Boolean>}
   */
  this.logout = function () {
    var logOutSuccess = false
    if (adalAuthContext.getCachedUser()){
      adalAuthContext.logOut();
      logOutSuccess = true;
    }
    adalAuthContext.clearCache();
    adalAuthContext.clearCacheForResource();
    return $q.resolve(logOutSuccess);
  };

  var adalAuthContext = new AuthenticationContext(IAM_CONFIGURATION.microsoft);
  var nativeAppFunctions = {
    clearSavedUrlParamsForToken: function () {},
    getSavedUrlParamsForToken: function () {
      return '';
    },
    login: function () {
      // eventManager.broadcast('start-login-attempt');
      return cordovaMessenger.requestResponse('requestNativeAdalLogin');
    },
    logout: function () {
      return cordovaMessenger.requestResponse('requestNativeAdalLogout');
    }
  };

  _.forOwn(this, function (value, key) {
    if (!nativeAppFunctions.hasOwnProperty(key)) {
      $log.error('property "' + key + '" exists on the default IAMManager object, but not on the nativeAppFunctions');
    }
  });
  var thiz = this;
  _.forOwn(nativeAppFunctions, function (value, key) {
    if (!thiz.hasOwnProperty(key)) {
      $log.error('property "' + key + '" exists on the nativeAppFunctions, but not on default IAMManager object');
    }
  });
  if (PlatformService.isApp) {
    _.assignIn(this,  nativeAppFunctions);
  }

})
